import { withStyles } from '@material-ui/core';

import LockScreenTopBar from './component';
import styles from './styles';

export default withStyles(styles)(LockScreenTopBar);
